import React, { useState } from "react"
import styled from "styled-components"

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalContainer = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  width: 90%;
  max-width: 500px;
  padding: ${({ theme }) => theme.spacing.lg};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
  @media (max-width: 480px) {
    width: 95%;
    padding: ${({ theme }) => theme.spacing.md};
  }
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.primary};
`

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.primaryText};
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
`

const InputField = styled.input`
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  width: 100%;
`

const SelectField = styled.select`
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  width: 100%;
`

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.md};
`

const SubmitButton = styled.button`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  border: none;
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
`

interface AddPropertyModalProps {
  onClose: () => void
  onAdd: (property: { address: string; postalCode: string; city: string; description: string; status: string }) => void
}

const AddPropertyModal: React.FC<AddPropertyModalProps> = ({ onClose, onAdd }) => {
  const [address, setAddress] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [city, setCity] = useState("")
  const [description, setDescription] = useState("")
  const [status, setStatus] = useState("Disponible")

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onAdd({ address, postalCode, city, description, status })
    onClose()
  }

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>Ajouter une propriété</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <form onSubmit={handleSubmit}>
          <ModalContent>
            <InputField type="text" placeholder="Adresse civil" value={address} onChange={(e) => setAddress(e.target.value)} required />
            <InputField type="text" placeholder="Code postal" value={postalCode} onChange={(e) => setPostalCode(e.target.value)} required />
            <InputField type="text" placeholder="Ville" value={city} onChange={(e) => setCity(e.target.value)} required />
            <InputField type="text" placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} required />
            <SelectField value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="Disponible">Disponible</option>
              <option value="Loué">Loué</option>
              <option value="Fermé">Fermé</option>
            </SelectField>
          </ModalContent>
          <ModalFooter>
            <SubmitButton type="submit">Ajouter</SubmitButton>
          </ModalFooter>
        </form>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default AddPropertyModal
